interface Comment {
  id: string
  author: string
  created_at: string
  content: string
  avatar: string
}

interface Faq {
  title: string
  description: string
}

interface Promotion {
  likes_count: number
  hasBenefits: boolean
  comments_count: number
  comments: Comment[]
  faqList: Faq[]
}

interface CollectionPromotion {
  [identifier: string]: Promotion
}

const defaultFAQ = [
  {
    title: 'Chi ha commentato il corso?',
    description: `Ogni feedback che leggi qui proviene direttamente da studenti come te,
    che hanno realmente acquistato e sperimentato il corso. Dopo
    l'acquisto, invitiamo ciascuno a condividere le proprie
    impressioni, garantendo valutazioni sincere e trasparenti.`,
  },
  {
    title: 'Come posso accedere al corso?',
    description: `Semplice, non appena completi l'acquisto, il corso sarà
    immediatamente disponibile nella tua bacheca personale. Nessuna attesa,
    nessuna complicazione. Inizia quando vuoi.`,
  },
  {
    title: 'Come posso ottenere assistenza?',
    description: `Per assistenza o segnalazioni, la nostra chat è pronta ad aiutarti.
    Scrivi per qualsiasi dubbio o per segnalare contenuti inappropriati,
    siamo qui 24/7.`,
  },
  {
    title: 'Posso accedere al corso anche da telefono e tablet?',
    description: `Certo, il corso è progettato per essere consultato ovunque ti trovi.
    Puoi accedere alle lezioni comodamente dal tuo smartphone o tablet,
    garantendoti la libertà di apprendere quando e come vuoi.`,
  },
]

const defaultReview: Promotion = {
  likes_count: 0,
  hasBenefits: false,
  comments_count: 0,
  comments: [],
  faqList: [],
}

const collectionPromotion: CollectionPromotion = {
  // Excel
  'iEOTG-S4AEF': {
    likes_count: 32,
    hasBenefits: true,
    comments_count: 208,
    comments: [
      {
        id: 'comment-01',
        author: 'Luca C.',
        created_at: '2 giorni fa',
        content:
          'Corso molto formativo e che permette di avere una panoramica decisamente soddisfacente, andando anche in profondità su tanti aspetti.',
        avatar: '',
      },
      {
        id: 'comment-02',
        author: 'Angela V.',
        created_at: '6 giorni fa',
        content:
          'Chiaro, semplice e magistralmente esplicato, per me che sono alle prime armi è un toccasana, complimenti.',
        avatar: '',
      },
      {
        id: 'comment-03',
        author: 'Roberto C.',
        created_at: '1 settimana fa',
        content:
          "Corso adattissimo, con esempi pratici e solidi che rappresentano la realtà. Mi è piaciuto tantissimo anche perché praticavo direttamente. D’altra parte, volevo abituarmi ad usare excel in inglese (perché ovviamente l'inglese è la base per capire meglio ed avere più opportunità anche), ed il fatto che il corso permette anche di vedere le formule in inglese e di trattare alcuni problemi in diverse modalità anche linguistiche è stato un più. Ringrazio Gilberto",
        avatar: '',
      },
      {
        id: 'comment-04',
        author: 'Giorgio T.',
        created_at: '2 settimana fa',
        content:
          'Bravissimo insegnante, spiega in maniera semplice e chiara e non è mai noioso. Corso preziosissimo per imparare ad utilizzare excel. Consigliato.',
        avatar: '',
      },
      {
        id: 'comment-05',
        author: 'Giulia A.',
        created_at: '2 settimane fa',
        content:
          'Ottimo corso, molto utile. Esposizione chiara e giuste le tempistiche di esposizione.',
        avatar: '',
      },
      {
        id: 'comment-06',
        author: 'Vanessa L.',
        created_at: '4 settimane fa',
        content:
          "Corso estremamente utile per imparare ad utilizzare Excel con molta più dimestichezza e furbizia. L'insegnante è davvero competente, chiaro, esaustivo e piacevole da seguire. Inoltre, ho trovato il percorso di apprendimento davvero ben strutturato, poiché parte dai fondamentali ed arriva a strumenti più complessi con gradualità e affiancamento costante. Davvero consigliato!",
        avatar: '',
      },
      {
        id: 'comment-07',
        author: 'Umberto S.',
        created_at: '1 mese fa',
        content: 'Chiaro e conciso, proprio quello che cercavo!',
        avatar: '',
      },
      {
        id: 'comment-08',
        author: 'Matteo D.',
        created_at: '1 mese fa',
        content:
          "Ottimo corso! Permette di acquisire conoscenze approfondite per l'utilizzo dello strumento Excel. I temi trattati sono spiegati con chiarezza e gradualmente, partendo da concetti base fino a funzioni più complesse e come impiegare le tabelle Pivot. Le spiegazioni, inoltre, sono orientate fortemente a come utilizzare Excel nel mondo lavorativo, fornendo alcuni spunti su come velocizzare l'analisi dati, senza dilungarsi troppo su tematiche poco attinenti allo scopo.",
        avatar: '',
      },
    ],
    faqList: defaultFAQ,
  },
  // Web dev
  'zfMK5-iDU0o': {
    likes_count: 33,
    hasBenefits: true,
    comments_count: 37,
    comments: [
      {
        id: 'comment-01',
        author: 'Alessandro B.',
        created_at: '1 settimana fa',
        content:
          'Le lezioni sono veramente molto chiare e spiegate nei dettagli. E sono ricche di esempi pratici che consentono di mettere subito in pratica quanto spiegato nei video.',
        avatar: '',
      },
      {
        id: 'comment-02',
        author: 'Alessio S.',
        created_at: '1 settimana fa',
        content:
          "Il corso è davvero ottimo per chi vuole iniziare in questo ambito. L'insegnante è molto chiara e precisa e cerca di rendere il contenuto molto semplice, in modo da far comprendere a tutti ciò che sta spiegando. Consiglio vivamente questo corso! :3",
        avatar: '',
      },
      {
        id: 'comment-03',
        author: 'Giulia B.',
        created_at: '3 settimane fa',
        content:
          'È un corsone!! Estremamente preciso lungo e dettagliato. Che bel lavoro!',
        avatar: '',
      },
      {
        id: 'comment-04',
        author: 'Ciro N.',
        created_at: '4 settimane fa',
        content: 'Ottimo corso, pieno di lezioni e spiegate molto bene!',
        avatar: '',
      },
      {
        id: 'comment-05',
        author: 'Guido S.',
        created_at: '4 settimane fa',
        content:
          "Ottimo corso per apprendere da zero il lavoro di web designer, molto concreto con gli esercizi, Simona è molto brava nello spiegare ed ho apprezzato molto l'introduzione del corso. Tempi giusti nelle spiegazioni e soprattutto ottimo che si faccia pratica. Consigliatissimo come corso!",
        avatar: '',
      },
      {
        id: 'comment-07',
        author: 'Ilenia M.',
        created_at: '1 mese fa',
        content:
          'Il corso è utilissimo, spiegato molto bene e in maniera chiara. Assolutamente consigliato per approcciarsi al web design e acquisire una solida base. Molto corposo, occorre tempo ma credo che ne valga la pena. Complimenti a Simona.',
        avatar: '',
      },
      {
        id: 'comment-08',
        author: 'Anna P.',
        created_at: '2 mesi fa',
        content:
          "Corso ottimo. L'insegnante è eccellente e chiara, riuscendo a creare un corso completo e ricco di contenuti. Completamente soddisfatta!",
        avatar: '',
      },
    ],
    faqList: defaultFAQ,
  },
  // Pole Dance
  '5xRMH-VS5Yj': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: defaultFAQ,
  },
  // Life Beauty
  'fF0Zs-BeoWx': {
    likes_count: 31,
    hasBenefits: true,
    comments_count: 25,
    comments: [
      {
        id: 'comment-01',
        author: 'Marco',
        created_at: '3 giorni fa',
        content:
          'Il Master di Fitoterapia del Dott. Di Pierro è stato una rivelazione! Le lezioni sono state estremamente informative, specialmente quelle sulla biofarmaceutica. Come farmacista, ho trovato preziosi spunti per migliorare la mia pratica professionale.',
        avatar: '',
      },
      {
        id: 'comment-02',
        author: 'Laura',
        created_at: '5 giorni fa',
        content:
          'Il Master ha superato le mie aspettative. La discussione su fibre e prodotti dimagranti, come il tè verde, è stata particolarmente rilevante per il mio lavoro. ',
        avatar: '',
      },
      {
        id: 'comment-03',
        author: 'Alberto',
        created_at: '1 settimana fa',
        content:
          "Come medico di base, trovo spesso pazienti che cercano alternative naturali o complementi ai trattamenti convenzionali. Il Master di Fitoterapia del Dott. Di Pierro ha aperto nuovi orizzonti nella mia pratica. Non solo ho appreso l'importanza dell'integrazione sicura e efficace della fitoterapia, ma ho anche acquisito una profonda comprensione delle interazioni fitoterapiche e farmacologiche. Il corso ha arricchito il mio approccio alla medicina allopatica, permettendomi di offrire ai miei pazienti opzioni di trattamento più ampie e informate. ",
        avatar: '',
      },
      {
        id: 'comment-04',
        author: 'Sandro',
        created_at: '1 settimana fa',
        content:
          'Ho migliorato la mia capacità di fornire consigli più informati sui supplementi e integratori fitoterapici ai miei clienti. ',
        avatar: '',
      },
      {
        id: 'comment-05',
        author: 'Arianna',
        created_at: '2 settimane fa',
        content:
          "Come nutrizionista, la mia principale preoccupazione è quella di integrare efficacemente la nutrizione e la salute generale dei miei pazienti. Il corso del Dott. Di Pierro ha fornito una prospettiva preziosa sull'importanza della fitoterapia nell'ambito della nutrizione. Ho acquisito una comprensione più profonda di come gli estratti vegetali possano essere utilizzati per migliorare vari aspetti della salute, come la gestione del peso, la salute metabolica e la regolazione del colesterolo. Le sessioni sul tè verde e le sue proprietà termogeniche sono state particolarmente illuminanti, offrendomi nuove strategie per aiutare i miei pazienti a raggiungere i loro obiettivi di salute. Inoltre, le lezioni sulla sindrome metabolica e la gestione degli zuccheri nel sangue hanno arricchito il mio approccio alla consulenza nutrizionale, consentendomi di offrire consigli più mirati e basati su evidenze scientifiche.",
        avatar: '',
      },
      {
        id: 'comment-06',
        author: 'Giuseppe',
        created_at: '2 settimane fa',
        content:
          "Sono rimasto colpito dalla qualità del corso e dalla competenza del Dott. Di Pierro. La sessione sull'ottimizzazione galenico-farmaceutica è stata particolarmente utile per il mio lavoro quotidiano.",
        avatar: '',
      },
      {
        id: 'comment-07',
        author: 'Giovanna',
        created_at: '3 settimane fa',
        content:
          'Lavorando in un ambiente clinico, è essenziale per me comprendere pienamente gli effetti e le interazioni dei farmaci che somministriamo. Il corso del Dott. Di Pierro mi ha fornito una conoscenza approfondita non solo della fitoterapia, ma anche di come essa si integra nella pratica farmaceutica moderna. Ho trovato particolarmente utili le lezioni sulla biofarmaceutica e la farmacocinetica dei fitoterapici. Questa comprensione mi aiuta ora a gestire meglio le terapie dei pazienti, soprattutto in termini di prevenzione di interazioni nocive e ottimizzazione dei regimi terapeutici.',
        avatar: '',
      },
      {
        id: 'comment-08',
        author: 'Giorgio',
        created_at: '4 settimane fa',
        content:
          "Il corso ha ampliato la mia comprensione su come integrare la fitoterapia nella pratica quotidiana, soprattutto nell'interazione farmaco-fitoterapico. Mi ha aiutato a prevenire potenziali interazioni avverse con i trattamenti convenzionali.",
        avatar: '',
      },
    ],
    faqList: defaultFAQ,
  },
  // Francini
  'XqCaq-t7SdC': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: defaultFAQ,
  },
  'uIgCq-s1US1': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: defaultFAQ,
  },
  'SYZFc-HJkYn': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: defaultFAQ,
  },
  '51e2d-bWRNB': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: defaultFAQ,
  },
  'iF4Kl-IJhb2': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: defaultFAQ,
  },
  'ngxLf-j80QV': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: defaultFAQ,
  },
  // Inglese
  'MKUwF-0Uj4x': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: [],
  },
  'xPd3U-VmmSW': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: [],
  },
  'fEQU3-7uCVp': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: [],
  },
  'btQVF-oBDJn': {
    likes_count: 0,
    hasBenefits: true,
    comments_count: 0,
    comments: [],
    faqList: [],
  },
  // Sergio Chiesa
  'JNg34-trqvq': {
    likes_count: 0,
    hasBenefits: false,
    comments_count: 3,
    comments: [
      {
        id: 'comment-01',
        author: 'Barbara B.',
        created_at: '1 mese fa',
        content:
          "Wow, il 'Coaching Safari' è stata un'avventura straordinaria che mi ha letteralmente trasportata! Non avrei mai pensato che un corso potesse essere così coinvolgente e trasformativo. La leggerezza e l'energia positiva che Sergio ha infuso in ogni incontro hanno reso l'apprendimento una vera delizia, quasi come se stessimo esplorando insieme le meraviglie di un safari reale. Ogni sessione si è rivelata un tesoro di conoscenze e ispirazioni, rendendo dolce ogni passo di questo viaggio. E poi, la fine del corso? Ah, mi ha lasciato un vuoto nel cuore, come se dicessi addio a un caro amico. Sergio ha quel tocco magico che rende ogni momento indimenticabile, unendo cuore, mente e spirito in un'esperienza unica. Che dire, sono già in attesa del prossimo viaggio insieme!",
        avatar: '',
      },
      {
        id: 'comment-02',
        author: 'Annalisa A.',
        created_at: '1 mese fa',
        content:
          "Partecipare al 'Coaching Safari' è stata un'esperienza illuminante, caratterizzata da un approccio pedagogico non convenzionale ma estremamente efficace. L'abilità di Sergio nel trasmettere concetti complessi con una leggerezza e una chiarezza esemplari ha reso il processo di apprendimento non solo accessibile ma profondamente stimolante. Ogni lezione si è rivelata essere un'opportunità unica per riflettere e crescere, un viaggio intellettuale che ha sfidato le mie aspettative e ampliato i miei orizzonti. La conclusione del corso ha lasciato una traccia indelebile, un misto di gratitudine per il percorso compiuto e la speranza di applicare queste preziose lezioni nella vita di tutti i giorni. L'approccio umanistico e profondamente empatico di Sergio ha reso questa esperienza unica, un percorso da raccomandare a chiunque cerchi di arricchire la propria vita.",
        avatar: '',
      },
      {
        id: 'comment-03',
        author: 'Francesco Z.',
        created_at: '1 mese fa',
        content:
          "All'inizio ero scettico riguardo al 'Coaching Safari'. Vedete, non sono il tipo che si lascia prendere facilmente dalle parole, preferisco i fatti. E devo dire che questo corso ha superato le mie aspettative. Sergio ha un approccio diretto e terra a terra che fa davvero la differenza. Ha smontato i concetti uno per uno, rendendoli non solo comprensibili ma applicabili nella vita reale. Niente fronzoli, solo sostanza. E questa è stata la vera sorpresa: imparare tanto senza il peso della formalità. Arrivare alla fine del corso senza nemmeno accorgersene dimostra quanto sia stato coinvolgente e, sì, devo ammetterlo, anche divertente. Sergio sa come fare centro, rendendo ogni incontro non solo istruttivo ma veramente ispiratore. Chapeau!",
        avatar: '',
      },
    ],
    faqList: [
      {
        title: '1. Quali metodi e strumenti vengono utilizzati nel corso?',
        description: `Il Coaching Safari introduce un metodo rivoluzionario e unico al mondo, che rende l'apprendimento visivo e creativo. Attraverso l'uso di disegni, grafici, esercizi pratici, e pratiche di mindfulness, il corso è accessibile e coinvolgente per un'ampia gamma di età e background, facilitando l'unione tra razionalità ed emozioni.`,
      },
      {
        title: "2. C'è un impegno specifico richiesto ai partecipanti?",
        description:
          "Si richiede un impegno attivo, che include la partecipazione agli incontri e l'attuazione degli esercizi. Fondamentale, tuttavia, è l'apporto personale di passione e apertura: portare il cuore al proprio percorso di crescita è essenziale, per il resto forniremo noi le competenze e la guida necessarie.",
      },
      {
        title:
          '3. Qual è la politica di rinuncia e rimborso per il Coaching Safari?',
        description:
          "Offriamo la possibilità di rinuncia entro due settimane dall'inizio per i corsi collettivi, e una settimana per i percorsi individuali one-to-one, con pieno diritto a rimborso. Questa politica assicura che i partecipanti possano avviare il loro percorso con la massima tranquillità, sapendo di avere la flessibilità di scegliere il percorso più adatto alle proprie esigenze di crescita.",
      },
      {
        title:
          '4. Sono disponibili sessioni di coaching aggiuntive oltre al programma base?',
        description:
          "Sì, per coloro che desiderano approfondire ulteriormente il proprio percorso di crescita personale e professionale, il Coaching Safari offre la possibilità di integrare il programma base con sessioni di coaching aggiuntive. Queste sessioni, disponibili a un costo aggiuntivo, sono personalizzate per rispondere alle specifiche esigenze e obiettivi dell'individuo, fornendo un livello di supporto e approfondimento ancora maggiore.",
      },
      {
        title: '5. È possibile seguire il Coaching Safari individualmente?',
        description:
          "Assolutamente. Il Coaching Safari prevede anche percorsi individuali one-to-one, dove l'affiancamento è costante e dedicato, e mirato al raggiungimento di obiettivi personali. Questa modalità, ideale per chi cerca un'esperienza più intensiva e personalizzata, segue la stessa politica di soddisfazione o rimborso del corso collettivo, ma con una finestra di rinuncia ridotta a una settimana, riflettendo la natura personalizzata del percorso.",
      },
    ],
  },
}

export const isCollectionInPromotion = (identifier: string) => {
  if (identifier in collectionPromotion) {
    return true
  }

  return false
}

export const hasPromoFAQ = (identifier: string) => {
  if (identifier in collectionPromotion) {
    return collectionPromotion[identifier].faqList.length > 0
  }

  return false
}

export const hasPromoBenefits = (identifier: string) => {
  if (identifier in collectionPromotion) {
    return collectionPromotion[identifier].hasBenefits
  }

  return false
}

export const getPromotion = (identifier: string): Promotion => {
  if (identifier in collectionPromotion) {
    return collectionPromotion[identifier]
  }

  return defaultReview
}
